import * as actions from "./system.actions";
import * as api from "./system.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./system.constants";
import * as hooks from "./system.hooks";
import * as promises from "./system.promises";
import reducer from "./system.reducer";
import { saga } from "./system.saga";
import * as selectors from "./system.selectors";
export var REDUCER_KEY_SYSTEM = REDUCER_KEY;
export var systemModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
